import React from 'react';
import styles from './ACE.module.css';
// You will need to add a photo of Dr. Lajmeet Kaur to your project's image folder


const ACE = () => {
    // Data for the B.Ed. program from the provided image
    const educationPrograms = [
        { 
            program: 'Bachelor of Education (B.Ed.)', 
            duration: '2 Years', 
            eligibility: 'Graduation in any discipline with eligibility as per government guidelines. *UPBED entrance exam is compulsory to take any admission.', 
            intake: '100', 
            approval: 'NCTE Approved GIS Ref: 3062226' 
        }
    ];

    return (
        <div className={styles.container}>
            <header className={styles.header}>
                <h1>About Apex College of Education</h1>
                <p>Founded to inspire and empower future educators, Apex College of Education is dedicated to excellence in teacher training and innovation. We focus on developing reflective, skilled, and compassionate teachers who make a real difference in the classroom.</p>
            </header>

            <section className={styles.principalMessage}>
                <div className={styles.principalImageContainer}>
                    <img src="https://res.cloudinary.com/ddkyeuhk8/image/upload/v1755454529/apex/5853626d-f4b8-4679-b6f6-b778773343dc.png" alt="Dr. Lajmeet Kaur, Principal" className={styles.principalImage} />
                </div>
                <div className={styles.principalText}>
                    <h2>Message from the Principal’s Desk</h2>
                    <p className={styles.quote}>"Teachers are the movers of an education system. They are the flag bearers of knowledge, values, empathy, and compassion—agents of change who shape the future."</p>
                    <p>At Apex, we are committed to producing responsible teachers for society who always place their students’ interests above their own. We strive to impart knowledge that fosters both wisdom and ethics, enabling our students to discover themselves through an inner journey.</p>
                    <h4>Dr. Lajmeet Kaur</h4>
                    <p>Principal, ACE</p>
                </div>
            </section>

            <section className={styles.programsOffered}>
                <h2>Programs Offered</h2>
                <div className={styles.tableContainer}>
                    <table className={styles.programsTable}>
                        <thead>
                            <tr>
                                <th>Program</th>
                                <th>Duration</th>
                                <th>Eligibility</th>
                                <th>Annual Intake</th>
                                <th>Affiliation(s)/Approval</th>
                            </tr>
                        </thead>
                        <tbody>
                            {educationPrograms.map((program, index) => (
                                <tr key={index}>
                                    <td data-label="Program">{program.program}</td>
                                    <td data-label="Duration">{program.duration}</td>
                                    <td data-label="Eligibility">{program.eligibility}</td>
                                    <td data-label="Annual Intake">{program.intake}</td>
                                    <td data-label="Approval">{program.approval}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </section>

            <section className={styles.uniqueFeatures}>
                <h2>Unique Features</h2>
                <ul>
                    <li><strong>Comprehensive B.Ed. Curriculum:</strong> Integrates pedagogical theory, subject expertise, and practical teaching skills.</li>
                    <li><strong>School Attachment & Block Teaching:</strong> Real-world classroom competence through short and extended school experiences.</li>
                    <li><strong>Service-Learning Project:</strong> A mandatory one-year project for holistic personal and professional growth.</li>
                    <li><strong>Internship & Mentorship:</strong> Regular internships and guidance from renowned educators.</li>
                    <li><strong>Guest Sessions by Experts:</strong> Exposure to best practices and innovations from accomplished academicians.</li>
                    <li><strong>Adherence to Latest Regulations:</strong> Fee structure and policies as per government and NCTE guidelines.</li>
                </ul>
            </section>

            <footer className={styles.footer}>
                <h3>Contact Information</h3>
                <p><strong>General Inquiries:</strong> +91-7351408009</p>
                <p><strong>Email:</strong> admissions@apex.in</p>
                <p className={styles.note}>
                    Program information is updated regularly. Applicants are advised to verify current policies before application. For details on B.Ed. norms and NCTE compliance, visit: National Council for Teacher Education (ncte.gov.in).
                    <br />
                    <strong>GIS Reference Number: 3062226</strong>
                </p>
            </footer>
        </div>
    );
};

export default ACE;